import store from "@/store";

// Read-only users may reach any route that only displays data, but routes whose
// sole purpose is to create or modify data send them back to the previous page.
export const notReadOnly = (_to, from, next) => {
	if (store.getters.readOnly) {
		next(from.name ? false : "/");
		return;
	}
	next();
};
